module.exports = __webpack_public_path__ + "static/media/Nokia 230 White.cf0d67b8.png";